<template>
  <b-container fluid>
    <s-empty-list
      v-if="showEmptyList"
      :empty-message="$t('messages.MA076.message')"
      :loading="loading"
    />
    <div
      v-else
      class="physical-chemical-tab"
    >
      <div class="physical-chemical-tab__checkbox-area mb-2">
        <b-checkbox
          :checked="allDiagnosticsToggled"
          @change="toggleAllDiagnostics"
        />
        <span>{{ $t(markAllTitleHandler) }}</span>
      </div>
      <div class="physical-chemical-tab__diagnostics-wrapper">
        <div
          v-for="norm in items.norm"
          :key="norm.norm"
        >
          <accordion-panel
            :id="norm.norm"
            :collapsed.sync="norm.collapsed"
          >
            <b-row
              class="pl-3"
              slot="title"
            >
              <b-checkbox
                :checked="isDiagnosticsFromNormSelected(norm)"
                @change="toggleAllDiagnosticsFromNorm($event, norm)"
              />
              <strong>
                {{ normTitleHandler(norm.norm) }}
              </strong>
            </b-row>
            <b-checkbox-group
              class="physical-chemical-tab__checkbox-group ml-3"
              v-model="selectedDiagnosticsProxy"
              text-field="name"
              value-field="id"
              stacked
              :options="norm.diagnostics"
            />
          </accordion-panel>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import AccordionPanel from '@/components/AccordionPanel';

export default {
  components: {
    AccordionPanel,
  },
  props: {
    selectedDiagnostics: {
      type: Array,
      default: () => ([]),
    },
    items: Object,
    loading: Boolean,
  },
  computed: {
    selectedDiagnosticsProxy: {
      get() {
        return this.selectedDiagnostics;
      },
      set(value) {
        this.$emit('update:selected-diagnostics', value);
      },
    },
    showEmptyList() {
      return isEmpty(this.items);
    },
    markAllTitleHandler() {
      return this.allDiagnosticsToggled ? 'reports.diagnostics-history.unmark-all' : 'reports.diagnostics-history.mark-all';
    },
    allDiagnosticsToggled() {
      const allDiagnostics = [];
      if (this.showEmptyList) {
        return false;
      }
      this.items.norm.forEach(norm => norm.diagnostics
        .forEach(diagnostic => allDiagnostics.push(diagnostic.id)));
      return allDiagnostics.every(item => this.selectedDiagnostics.includes(item));
    },
  },
  methods: {
    toggleAllDiagnostics(event) {
      if (this.showEmptyList) {
        return;
      }
      if (event) {
        this.items.norm.forEach(norm => norm.diagnostics
          .forEach(diagnostic => this.addSelectedItem(diagnostic.id)));
        return;
      }
      this.items.norm
        .forEach(norm => norm.diagnostics
          .forEach(diagnostic => this.removeSelectedItem(diagnostic.id)));
    },
    toggleAllDiagnosticsFromNorm(event, norm = []) {
      if (event) {
        norm.diagnostics.forEach(it => this.addSelectedItem(it.id));
        return;
      }
      norm.diagnostics.forEach(it => this.removeSelectedItem(it.id));
    },
    isDiagnosticsFromNormSelected(norm = []) {
      return norm.diagnostics.every(item => this.selectedDiagnostics.includes(item.id));
    },
    addSelectedItem(selectedItem) {
      const itemExists = this.selectedDiagnostics.some(
        selectedDiagnostic => selectedDiagnostic === selectedItem,
      );
      if (itemExists) return;
      this.selectedDiagnosticsProxy.push(selectedItem);
    },
    removeSelectedItem(selectedItem) {
      const itemIndex = this.selectedDiagnostics.findIndex(
        selectedDiagnostic => selectedDiagnostic === selectedItem,
      );
      this.selectedDiagnosticsProxy.splice(itemIndex, 1);
    },
    normTitleHandler(norm) {
      return this.$t(`enums.engineering.physical-chemical.norms.${norm}`);
    },
  },
};
</script>

<style scoped lang="sass">
  @import "src/styles/defaults/variables.sass"
  .physical-chemical-tab
    &__diagnostics-wrapper
      border: 1px solid $color-border-gray
      border-radius: 5px
      max-height: 300px
      overflow-y: auto
      overflow-x: hidden
    &__checkbox-area
      display: flex
      flex-wrap: nowrap
      margin-bottom: 3px
    &__diagnostic-header
      padding: 4px 10px
      display: flex
      align-items: center
    &__checkbox-group ::v-deep
      .custom-control.custom-checkbox
        margin-bottom: 5px
    ::v-deep .accordion-panel
      &__slot-container .custom-control-label
        font-weight: normal
      &__header
        padding: 4px 10px !important
        margin-bottom: 2px
</style>
